import { render, staticRenderFns } from "./MaterialWaterfall.vue?vue&type=template&id=d4f5367e&scoped=true&"
import script from "./MaterialWaterfall.vue?vue&type=script&lang=js&"
export * from "./MaterialWaterfall.vue?vue&type=script&lang=js&"
import style0 from "./MaterialWaterfall.vue?vue&type=style&index=0&id=d4f5367e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f5367e",
  null
  
)

export default component.exports